import { Footer, Header } from 'components'
import React, { useEffect } from 'react'

import { Custom02 as Custom02Container } from 'containers'
import { helmet } from 'utils'
import styles from './Custom_02.module.scss'

const SEO_Data = helmet({
  title: 'Mobile Prüfvorrichtung',
  description: 'Klein, Leicht und Leistungsstark, unser eigens entwickelter Spezialprüfstand für Hebe-, Zug- und Spanngeräte, Magnete u.v.m.'
})

const Custom02 = () => {

  useEffect(() => {
    window.scroll(0,0)
  });

  return (
    <div>
      {/* Insert Helmet Data */}
      {SEO_Data}

      {/* Render Screen */}
      <Header />
      <article className={styles.content}>
        <Custom02Container />
      </article>
      <Footer />
    </div>
  )
}

export { Custom02 as default }